module.exports = __webpack_public_path__ + "static/media/luggage.deef9e55.svg";